import React from 'react';
import LidarOverviewContextProvider from './LidarOverviewContext';
import LidarTesterContextProvider from './LidarTesterContext';
import ProvisioningContextProvider from './ProvisioningContext';

/**
 * Consolidated context provider that wraps all Lidar-related contexts
 * This simplifies the component structure and provides a single entry point
 * for all Lidar contexts as suggested in the code review
 *
 * Note: This provider requires PermissionsContext to be available in the component tree
 * since LidarOverviewContextProvider depends on it for authorization checks.
 */
const LidarContextProvider = ({ children }) => {
    return (
        <LidarOverviewContextProvider>
            <LidarTesterContextProvider>
                <ProvisioningContextProvider>
                    {children}
                </ProvisioningContextProvider>
            </LidarTesterContextProvider>
        </LidarOverviewContextProvider>
    );
};

export default LidarContextProvider;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/context/LidarContextProvider.js